// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconChevronDown = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M53.3426 25.384C52.4481 24.4895 51.5104 23.5519 50.616 22.6573C49.7214 21.7629 48.6008 21.7827 47.7385 22.7082C47.0661 23.4299 36.5852 34.6799 32 39.6017C27.4149 34.6799 16.9339 23.4299 16.2615 22.7082C15.3992 21.7827 14.2785 21.7628 13.384 22.6573C12.4895 23.5519 11.5518 24.4895 10.6574 25.384C9.76283 26.2785 9.78267 27.3992 10.7082 28.2615C11.6337 29.1238 29.7785 46.0279 30.6366 46.8274C31.4948 47.6269 32.5053 47.6269 33.3634 46.8274C34.2214 46.0279 52.3662 29.1239 53.2918 28.2615C54.2173 27.3992 54.2371 26.2785 53.3426 25.384Z" />
    </svg>
  );
};
